var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lookupviewvar"},[_c('div',{staticClass:"lookupvar"},[_vm._t("lookup")],2),_c('div',{staticClass:"viewvar"},[_vm._t("viewdetail")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }